import React from "react";
import { Button, Card, Table, Tag, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import useTrainingGroup from "PlatForms/OrgLMS/Hooks/LearnerHooks/useTrainingGroup";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const { Text } = Typography;
const TrainingGroup = () => {
  const { loadingGroups, groupData } = useTrainingGroup();
  const navigate = useNavigate();
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const columns = [
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "groupName",
      render: (text, record) => (
        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
          <Text strong>{text}</Text>
          {record.isRetryTraining && (
            <Tag color="orange" style={{ marginLeft: 8, fontWeight: "bold" }}>
              Repeated
            </Tag>
          )}
        </div>
      ),
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: "Members Count",
      dataIndex: "membersCount",
      key: "membersCount",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button type="link" disabled={isBlocked} onClick={() => !isBlocked && navigate(`/group-detail/${record.id}`)}>
          View Detail
        </Button>
      ),
    },
  ];
  return (
    <Card loading={loadingGroups} title="Trainings Group" className="card-professional">
      <Table columns={columns} dataSource={groupData} rowKey="groupId" />
    </Card>
  );
};
export default TrainingGroup;
